import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=54054d58&"
import script from "./CategoryFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CategoryFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54054d58')) {
      api.createRecord('54054d58', component.options)
    } else {
      api.reload('54054d58', component.options)
    }
    module.hot.accept("./CategoryFilters.vue?vue&type=template&id=54054d58&", function () {
      api.rerender('54054d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/CategoryFilters/CategoryFilters.vue"
export default component.exports